<template>
    <EmployeeApproveServiceReports></EmployeeApproveServiceReports>
</template>
<script>
    import EmployeeApproveServiceReports from '@/components/EmployeeApproveServiceReports.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeeApproveServiceReports
        }
    }
</script>